import axios from "axios";
import { toast } from "react-toastify";
import TokenService from "./token.service";
import CommonURL from "../utils/CommonURL";


const BASE_URL =  CommonURL.BASE_URL;

//Create global cancellation token
export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// for multiple requests
let isRefreshing = false;
let failedQueue = [];

axiosPrivate.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();

    if (token) {
      config.headers["Authorization"] = "Bearer " + token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosPrivate.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalRequest = err?.config;

    if (err.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosPrivate(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        axiosPrivate
          .post("auth/refresh-token", {
            refreshToken: TokenService.getLocalRefreshToken(),
          })
          .then(({ data }) => {
            if (!data.success || data.message === "Invalid refresh token") {
              window.location.href = "/login";
              toast.error(data.message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
            }
            TokenService.setUser(data.data.token);
            axiosPrivate.defaults.headers.common["Authorization"] = "Bearer " + data.data.token;
            originalRequest.headers["Authorization"] = "Bearer " + data.data.token;
            processQueue(null, data.data.token);
            resolve(axiosPrivate(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
            window.location.href = "/login";
          })
          .then(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(err);
  }
);
